module.exports = __webpack_public_path__ + "resource/img/history.68ca8966.png";